import API from 'js/lib/api';

const courseFeedbackCountsAPI = API('/api/courseFeedbackCounts.v1', {
  type: 'rest',
});

export default courseFeedbackCountsAPI;
